module.exports = __webpack_public_path__ + "img/dark-mud-decal-24.ee0de8dd.png";